import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const button = event.currentTarget
    const section = button.closest(".experience-section-card")
    if (!section) return

    const isExpanded = section.classList.toggle("is-expanded")
    button.textContent = isExpanded
      ? button.dataset.expandedLabel
      : button.dataset.collapsedLabel
    button.setAttribute("aria-expanded", isExpanded ? "true" : "false")
  }

  toggleDetails(event) {
    if (event.type === "keydown") {
      if (event.key !== "Enter" && event.key !== " ") return
      event.preventDefault()
    }

    const item = event.currentTarget.closest(".experience-timeline__item")
    if (!item) return

    const details = item.querySelector(".experience-accordion")
    if (!details) return

    details.open = !details.open
  }
}
